import styles from './PromotionCard.module.css';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../Buttons';

export interface PromotionCardProps {
	title: string;
	subtitle: string;
	buttonText?: string;
	onButtonClick?: (() => void) | string;
	className?: string;
}

export const PromotionCard = ({
	title,
	subtitle,
	buttonText,
	onButtonClick,
	className,
}: PromotionCardProps) => {
	const navigate = useNavigate();

	const handleClick = () => {
		if (typeof onButtonClick === 'string') {
			navigate(onButtonClick);
		} else if (onButtonClick) {
			onButtonClick();
		}
	};

	return (
		<div className={`${styles.card} ${className ?? ''}`}>
			<div className={styles.content}>
				<span className={styles.title}>{title}</span>
				<span className={styles.subtitle}>{subtitle}</span>
			</div>
			<div className={styles.buttonContainer}>
				{' '}
				{buttonText && (
					<Button variant="secondary" className={styles.button} onClick={handleClick}>
						{buttonText}
					</Button>
				)}
			</div>
		</div>
	);
};
